var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{staticClass:"input_color",attrs:{"options":_vm.options},model:{value:(_vm.newSelect),callback:function ($$v) {_vm.newSelect=$$v},expression:"newSelect"}})}
var staticRenderFns = []

export { render, staticRenderFns }